import React, { Component } from 'react'
import { connect } from 'react-redux';
import { toArray } from 'utils/helpers';
import { change, formValueSelector, Field } from 'redux-form';
import Button from 'components/Button';
import PreventAutoComplete from 'components/PreventAutoComplete';
import Loader from 'components/Loader';
import { colors } from 'globalStyles';
import { StyledForm, FieldHead, FormGroupWithoutBorderBottom, UpgradeText, ChannelFormSection, FormGroup, ValidIndicator, ValidIndicatorContainer } from './styledComponents';

import { ToastContainer, toast } from 'react-toastify';
import {
  ChannelSelectField,
  ChannelInputField,
  ChannelUrlInputField,
  ChannelDateInputField,
  ChannelSwitchField,
  ChannelAdministratorsSelect,
  ChannelGroupRadioInput
} from './components';
import TimezonePicker from 'react-timezone';
import Tooltip from 'components/Tooltip';
import Icon from 'components/Icon';
import Divider from 'components/Divider';
import 'react-select/dist/react-select.css';
import { validateChannelSlugRequest } from '../actions';

const notify = () => toast('Changes Saved!');

class BasicInfoForm extends Component {
  state = {
    channelUrlTimeout: null
  }

  render() {
    const {
      handleSubmit,
      submitting,
      pristine,
      fetchClients,
      clients,
      channelName,
      nextTab,
      password,
      invalid,
      edit,
      disabled,
      turnOffPassword,
      isPhotographerOwner,
      isPhotographer,
      clearPassword,
      setTImeZone,
      timezoneValue,
      passwordRequired,
      selectedChannelAdministrators,
      setChannelAdministrators,
      enterpriseAdmins,
      channelAdministrators,
      permissionRole,
      name,
      galleryUrl,
      setGalleryUrl,
      validateSlug,
      slugIsValid,
      slugIsValidating,
      isNew
    } = this.props;
    const handleTimeZoneChange = (val) => setTImeZone(val);
    return (
      <StyledForm autoComplete="off" onSubmit={handleSubmit} className="basic-info-form">
        <ToastContainer />
        <FormGroup>
        <ChannelFormSection>
          <div style={{display: 'none'}}>
            <Field
              name="is_new"
              component={ChannelSwitchField}
              checked={isNew}
            />
          </div>
          <Field
            label='Client Name'
            placeholder='ACME Corp.'
            name='client'
            type='text'
            component={ChannelSelectField}
            fetchOptions={fetchClients}
            options={toArray(clients).map((client) =>
              ({ label: client.name, value: client.id })
            )}
            newOptionText='+ Add New Client'
            tooltip='Enter a client name that will help you find this channel later. It might be the name of the person or company whose logo is going to appear in it, or it might be the name of your own company (if different).'
          />
          <Field
            name='name'
            type='text'
            component={ChannelInputField}
            label='Channel Name'
            placeholder='Channel Name'
            tooltip='Name this channel something that will help you remember what it is for. For example, if you plan to use this channel only at a specific event, you might use that event name somewhere in the channel name.'
            onChange={e => { 
              const urlFixed = (value) => value.toLowerCase().trimStart().replace(/ /g, '-').replace(/[^a-z\-_0-9]/g, '').replace(/[-]+$/, '');
              if (!galleryUrl || urlFixed(name) === galleryUrl) {
                setGalleryUrl(urlFixed(e.target.value))}
            }}
          />
            <ValidIndicatorContainer>
              <Field
                autoComplete="off"
                name='slug'
                type='text'
                component={ChannelUrlInputField}
                label='Gallery URL'
                placeholder='channelURL'
                channelName={channelName}
                validateSlug={validateSlug}
                channelUrlTimeout={this.state.channelUrlTimeout}
                setChannelUrlTimeout={(timeoutObj) =>
                  this.setState({ channelUrlTimeout: timeoutObj })
                }
                tooltip={`This is the web address where the online gallery of images for this channel will live. We'll create a suggested URL for you based on the channel name you entered, but you can change it to whatever you like (as long as the URL hasn't already been taken)`}
              />
              {typeof galleryUrl !== 'undefined' ? (
                <ValidIndicator>
                  { slugIsValidating ? <Loader color={colors.MAIN_COLOR}/> :  slugIsValid ? (
                    <Tooltip
                      className='tooltip'
                      width='200px'
                      text={`Nice choice! This URL looks good on you.`}
                    ><Icon name='check' size={15} fill={colors.GREEN} /></Tooltip>
                  ) : (
                    <Tooltip
                      className='tooltip'
                      width='200px'
                      text={`This URL is already taken. Please choose another.`}
                    >
                      <Icon name='x' size={13} fill={colors.RED} />
                    </Tooltip>
                  )}
                </ValidIndicator>
              ) : (
                ''
              )}
            </ValidIndicatorContainer>
          {
            <FormGroupWithoutBorderBottom>
              <FieldHead>
                <div>
                  <strong>password protect gallery</strong>
                  <h3>Require a password to access the online gallery</h3>
                </div>
                <div>
                  <Field
                    name='password_required'
                    type='password'
                    component={ChannelSwitchField}
                    clearPassword={clearPassword}
                    turnOffPassword={turnOffPassword}
                    password={password}
                    checked={(password && password !== '')}
                    onChange={(e) => {
                      if (e === true || (password && password !== '')) {
                        clearPassword();
                        turnOffPassword()
                      }
                    }}
                  />
                </div>

              </FieldHead>
              <div className={(passwordRequired || (password && password !== "")) ? 'display_block' : 'display_none'}>
                <Field
                  autoComplete="off"
                  name='password'
                  type='password'
                  showPasswordButton={true}
                  component={ChannelInputField}
                  label='Gallery Password'
                  placeholder='password'
                />
              </div>
            </FormGroupWithoutBorderBottom>
          }
          {
            !isPhotographer && !edit &&
              <FormGroupWithoutBorderBottom className='customization-type'>
                <FieldHead className='tooltip'>
                  <div><strong>customization type</strong></div>
                  <Tooltip className='tooltip' width='200px' text={`If the client or event for this channel doesn't already have graphics you can use (like a logo and photo filters), you could use one of our Movebooth themes instead. This option is really popular for weddings and other personal events`}>
                    <Icon size='12' name='help' />
                  </Tooltip>
                </FieldHead>
                <Field
                  name='useMoveboothTheme'
                  component={ChannelGroupRadioInput}
                />
              </FormGroupWithoutBorderBottom>
          }
          {
            <Field
              name={isPhotographerOwner ? 'event_date' : 'active_until'}
              type='date'
              component={ChannelDateInputField}
              label={isPhotographerOwner ? 'Event Date' : 'Active Until'}
              placeholder={isPhotographerOwner ? 'Select Event Date' : 'No End Date'}
              required={isPhotographerOwner ? true : false}
              disabled={isPhotographerOwner ? disabled : false}
              style={{ 'z-index': 1 }}
            />
          }
          {
            isPhotographer ?
              <div>
                <label className="channel-forms__basic-info-event-time-zone-label"> Event Time Zone </label>
                <div>
                  <Field
                    type=''
                    name='time_zone'
                    required={true}
                    component={() =>
                      <TimezonePicker
                        placeholder="Select timezone..."
                        onChange={timezone => handleTimeZoneChange(timezone)}
                        value={timezoneValue}
                        inputProps={{
                          placeholder: 'Select Timezone...',
                        }}
                      />
                    }
                  />
                </div>
              </div>
              :
              ''
          }
          {permissionRole == "super_admin"
            ?
            <div>
              <Field
                name='channel_administrators'
                component={ChannelAdministratorsSelect}
                onChange={setChannelAdministrators}
                enterpriseAdmins={enterpriseAdmins}
                multi={true}
                selectedChannelAdministrators={selectedChannelAdministrators || channelAdministrators}
                placeholder="Select Channel Administrators"
              />
            </div>
            :
            ''
          }
          <PreventAutoComplete />
        </ChannelFormSection>
        </FormGroup>
        <Divider marginBottom={48}></Divider>
        <UpgradeText className='left-pos pdd-20'>Looking for more? Send us a suggestion.</UpgradeText>
        <div className='channel-forms__group'>
          {edit ? (
            <Button
              type='submit'
              onClick={notify}
              disabled={submitting || pristine || invalid ||!slugIsValid || slugIsValidating}
            >
              Save
            </Button>
          ) : (
            <Button
              type='button'
              onClick={() => nextTab()}
              disabled={submitting || pristine || invalid || !slugIsValid || slugIsValidating}
            >
              Save and Next
            </Button>
          )}
        </div>
      </StyledForm>
    )
  }
}

const selector = formValueSelector('channelForm');

const mapStateToProps = (state) => {
  return {
    timezoneValue: selector(state, 'time_zone'),
    passwordRequired: selector(state, 'password_required'),
    name: selector(state, 'name'),
    galleryUrl: selector(state, 'slug'),
    selectedChannelAdministrators: selector(state, 'channel_administrators'),
    channelAdministrators: state.channels.channelDetails && state.channels.channelDetails.users.map(u => ({ value: u.id, label: u.first_name })),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearPassword: () => dispatch(change("channelForm", "password", '')),
    validateSlug: (q) => dispatch(validateChannelSlugRequest(q)),
    turnOffPassword: () => dispatch(change("channelForm", "password_required", false)),
    setTImeZone: (val) => dispatch(change('channelForm', 'time_zone', val)),
    setChannelAdministrators: (value) => dispatch(change('channelForm', 'channel_administrators', value)),
    setGalleryUrl: (value) => dispatch(change('channelForm', 'slug', value)),
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(BasicInfoForm)




// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/BasicInfoForm.js